// no-dd-sa:javascript-best-practices/no-unreachable
import { observable, action, makeObservable } from 'mobx';

import { VERIFICATION_INTENT } from 'constants/verification';
import { setCookie } from 'utils/cookie';

class PODStore {
  isRequested = false;
  currentStep = 0;
  imagesPOD = [];
  isPODFeedback = false;
  isDisplayed = false;
  isChanged = false;
  isPreviewImage = false;
  verificationIntent = VERIFICATION_INTENT.POD;

  constructor(appStore) {
    this.appStore = appStore;
    makeObservable(this, {
      currentStep: observable,
      isRequested: observable,
      imagesPOD: observable,
      updateCurrentStep: action,
      isPODFeedback: observable,
      isDisplayed: observable,
      isChanged: observable,
      updateField: action,
      isPreviewImage: observable,
      verificationIntent: observable,
      startVerification: action,
      cancelVerification: action,
      completeVerification: action,
      setImagesPOD: action,
      updateIsRequested: action,
    });
  }

  updateCurrentStep(step) {
    this.currentStep = step;
  }

  setImagesPOD(images) {
    // Ensure images is always an array to prevent map errors
    this.imagesPOD = Array.isArray(images) ? images : [];
  }

  updateField(field, val) {
    this[field] = val;
  }

  updateIsRequested(value) {
    this.isRequested = value;
  }

  // Mobile only: show the verification steps inline in the page (same as View POD) instead of the full screen dialog
  startVerification(intent) {
    this.verificationIntent = intent;
    this.currentStep = 1;
    this.appStore.deliveryStore.setDialogErrorMsg('');
  }

  cancelVerification() {
    this.verificationIntent = VERIFICATION_INTENT.POD;
    this.isRequested = false;
    this.currentStep = 0;
    this.appStore.deliveryStore.setDialogErrorMsg('');
  }

  completeVerification() {
    const { deliveryStore } = this.appStore;
    const intent = this.verificationIntent;
    this.verificationIntent = VERIFICATION_INTENT.POD;
    this.isRequested = false;

    if (intent === VERIFICATION_INTENT.FEEDBACK) {
      // Same data loading as VerificationToken does after verifying inside the feedback dialog.
      // Clear old photos first so a failed POD request doesn't leave stale ones in the feedback dialog.
      this.setImagesPOD([]);
      deliveryStore.getPOD((res) => this.setImagesPOD(res.data));
      deliveryStore.getPackageLocation();
      deliveryStore.getFeedback();
      this.currentStep = 4;
      deliveryStore.openDialog(4);
      return;
    }

    this.currentStep = 0;
    if (intent === VERIFICATION_INTENT.POD) return;

    // Match the token lifetime of the dialog flow (DeliveryStore.processNextStep)
    setCookie('axl_shipment_token', deliveryStore.token, 1);
    if (intent === VERIFICATION_INTENT.LIVE_DETAILS) {
      deliveryStore.getDelivery(deliveryStore.trackingCode);
    } else if (intent === VERIFICATION_INTENT.MANAGE_DELIVERY) {
      deliveryStore.openDialog(3);
    }
  }
}

export default PODStore;
